/* eslint-disable no-undef */

import { getAuth, signOut } from "firebase/auth";
import { authJsonEdit, authJsonGet, base_url, getSavedUser, post, postNew, upload } from "functions/BaseAxios";
import { credsJQL } from "functions/JQL/UserJQL";
import { showUnderConstructionAlert } from "../general/action";
import { getRecentOpenTrips } from "../listing/homeAction";
import { AUTH_CREDS_KEY, AUTH_USER_KEY, clearAuthSession, setSecureItem } from "utils/security";

export const GET_USER = 'GET_USER';
export const GET_LOADING_LOGIN = 'GET_LOADING_LOGIN';
export const LOGIN_FALSE = 'LOGIN_FALSE';
export const googleLogin = (token: any) => {
    return async (dispatch: DispatchUser) => {
        var data = await apiLogin({
            token: token,
            fcm: null,
        });
        if (data && data.user) {
            setSecureItem(AUTH_USER_KEY, data.user);
            dispatch({
                type: GET_USER,
                payload: data.user,
            });
        } else {
            dispatch({
                type: GET_USER,
                payload: LOGIN_FALSE,
            });
        }
    };
};

export const googleLoginNew = (token: any) => {
    return async (dispatch: DispatchUser) => {
        var data = await apiLoginNew({
            token: token,
        });
        if (data && data.user) {
            setSecureItem(AUTH_USER_KEY, data.user);
            dispatch({
                type: GET_USER,
                payload: data.user,
            });
        } else {
            dispatch({
                type: GET_USER,
                payload: LOGIN_FALSE,
            });
        }
    };
};

export const emailSignUp = (data: any) => {
    return async (dispatch: DispatchUser) => {
        var result = await apiLogin(data);
        if (result && result.user) {
            setSecureItem(AUTH_USER_KEY, result.user);
            dispatch({
                type: GET_USER,
                payload: result.user,
            });
        } else {
            dispatch({
                type: GET_USER,
                payload: LOGIN_FALSE,
            });
        }
    };
};

export const emailLogin = (token: any) => {
    return async (dispatch: DispatchUser) => {
        var result = await apiLogin({
            token: token,
            fcm: null,
        });
        if (result && result.user) {
            setSecureItem(AUTH_USER_KEY, result.user);
            dispatch({
                type: GET_USER,
                payload: result.user,
            });
        } else {
            dispatch({
                type: GET_USER,
                payload: LOGIN_FALSE,
            });
        }
    };
};

export const updateMyAvatar = async (file: any, pid: any) => {
    var data = await upload({
        file
    });
    if (data.code) {
        return errorAlert();
    } else {
        const newData = {
            profile: [{
                id: pid,
                avatar: `${base_url}${data.urls[(data.urls).length - 1]}`,
            }],
        };
        var res = await authJsonEdit(newData);
        return getFullCreds();
    };
}

export const errorAlert = () => {
    return showUnderConstructionAlert(true, "Cannot perform the action, please try again later", "WARNING");
}

export const errorAlert1 = (param: any) => {
    return showUnderConstructionAlert(true, param, "WARNING");
}

export const updateMyProfile = async (data: any) => {
    const newData = {
        profile: data,
    };
    var res = await authJsonEdit(newData);
    return getFullCreds();
};

export const updateMyProfileGuide = async (data: any) => {
    const newData = {
        guideDetail: data,
    };
    var res = await authJsonEdit(newData);
    return getFullCreds();
};


export const checkLogin = () => {
    return getFullCreds()
}

export const logOut = () => {
    return async (dispatch: DispatchUser) => {
        try {
            const auth = getAuth();
            await signOut(auth);
        } catch (e) {
            console.warn('Firebase signout error or uninitialized auth', e);
        }
        clearAuthSession();
        dispatch({
            type: GET_USER,
            payload: LOGIN_FALSE,
        });
    };
}

export const setLoading = (load: string | null) => {
    return async (dispatch: DispatchLoadingLogin) => {
        dispatch({
            type: GET_LOADING_LOGIN,
            payload: load
        });
    }
}

const apiLogin = async (data: any) => {
    try {
        const signIn = await post('api/sign-in', data);
        if (signIn.code === 200) {
            var creds = signIn.payload;
            setSecureItem(AUTH_CREDS_KEY, creds);
            return creds;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
};

const apiLoginNew = async (data: any) => {
    try {
        const signIn = await postNew('api/sign-in', data);
        if (signIn.code === 200) {
            var creds = signIn.payload;
            setSecureItem(AUTH_CREDS_KEY, creds);
            return creds;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
};

export const getFullCreds = () => {
    return async (dispatch: DispatchUser) => {
        var creds = await getSavedUser();
        if (creds?.token) {
            var result = await authJsonGet(credsJQL(creds.user.id));
            if (result.code !== 200 || !result.payload?.user?.[0]) {
                dispatch({
                    type: GET_USER,
                    payload: LOGIN_FALSE,
                });
            } else {
                let userObj = result.payload.user[0];
                userObj['guideDetail'] = userObj.guideDetail?.[0] || null;
                userObj['profile'] = userObj.profile?.[0] || null;
                setSecureItem(AUTH_USER_KEY, userObj);
                dispatch({
                    type: GET_USER,
                    payload: userObj,
                });
            }
        } else {
            dispatch({
                type: GET_USER,
                payload: LOGIN_FALSE,
            });
        }
    };
}